import { render, staticRenderFns } from "./lostinself.vue?vue&type=template&id=0720d160&scoped=true&"
import script from "./lostinself.vue?vue&type=script&lang=js&"
export * from "./lostinself.vue?vue&type=script&lang=js&"
import style0 from "./lostinself.vue?vue&type=style&index=0&id=0720d160&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0720d160",
  null
  
)

export default component.exports